export const ErrorCode = {
  UnsupportedDevice: 1,
  UnsupportedBrowser: 2,
  ScreenTooSmall: 3,
  InvalidInvocation: 4,
};
